import { ModernMainMenuItem } from 'src/models/menu';

import { Callback } from 'src/util/query/models/Callback';

export class GetAllMenuItemsForTheUserQueryCallBack extends Callback<ModernMainMenuItem[]> {
	public constructor(private readonly setMainMenuItems: (payload: Array<ModernMainMenuItem>) => void) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Array<ModernMainMenuItem>): void => {
		this.setMainMenuItems(successResponse);
	};
}
